import { render, staticRenderFns } from "./AllSeal.vue?vue&type=template&id=afb2afba&scoped=true&"
import script from "./AllSeal.vue?vue&type=script&lang=js&"
export * from "./AllSeal.vue?vue&type=script&lang=js&"
import style0 from "./AllSeal.vue?vue&type=style&index=0&id=afb2afba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb2afba",
  null
  
)

export default component.exports